import { gql, type TypedDocumentNode } from "@apollo/client";

interface FacilityGovernanceRoleMutationResult {
  success: boolean;
  message: string;
  facilityGovernanceRole?: {
    id: string;
    status: string;
  } | null;
}

export interface UpdateFacilityGovernanceRoleNoteInput {
  content: string;
  priority: string;
  title?: string;
}

export interface UpdateFacilityGovernanceRoleMutationData {
  updateFacilityGovernanceRole: FacilityGovernanceRoleMutationResult;
}

export interface UpdateFacilityGovernanceRoleMutationVariables {
  input: {
    id: string;
    facilityGovernanceTitleId: string;
    note?: UpdateFacilityGovernanceRoleNoteInput | null;
  };
}

export const UPDATE_FACILITY_GOVERNANCE_ROLE_MUTATION: TypedDocumentNode<
  UpdateFacilityGovernanceRoleMutationData,
  UpdateFacilityGovernanceRoleMutationVariables
> = gql`
  mutation UpdateFacilityGovernanceRole($input: BackofficeUpdateFacilityGovernanceRoleInput!) {
    updateFacilityGovernanceRole(input: $input) {
      success
      message
      facilityGovernanceRole {
        id
        status
      }
    }
  }
`;

export interface ArchiveFacilityGovernanceRoleMutationData {
  archiveFacilityGovernanceRole: FacilityGovernanceRoleMutationResult;
}

export interface ArchiveFacilityGovernanceRoleMutationVariables {
  id: string;
}

export const ARCHIVE_FACILITY_GOVERNANCE_ROLE_MUTATION: TypedDocumentNode<
  ArchiveFacilityGovernanceRoleMutationData,
  ArchiveFacilityGovernanceRoleMutationVariables
> = gql`
  mutation ArchiveFacilityGovernanceRole($id: ID!) {
    archiveFacilityGovernanceRole(id: $id) {
      success
      message
      facilityGovernanceRole {
        id
        status
      }
    }
  }
`;

export interface UnarchiveFacilityGovernanceRoleMutationData {
  unarchiveFacilityGovernanceRole: FacilityGovernanceRoleMutationResult;
}

export interface UnarchiveFacilityGovernanceRoleMutationVariables {
  id: string;
}

export const UNARCHIVE_FACILITY_GOVERNANCE_ROLE_MUTATION: TypedDocumentNode<
  UnarchiveFacilityGovernanceRoleMutationData,
  UnarchiveFacilityGovernanceRoleMutationVariables
> = gql`
  mutation UnarchiveFacilityGovernanceRole($id: ID!) {
    unarchiveFacilityGovernanceRole(id: $id) {
      success
      message
      facilityGovernanceRole {
        id
        status
      }
    }
  }
`;

export interface CreateFacilityGovernanceRoleNoteInput {
  content: string;
  priority: string;
  title?: string;
}

export interface CreateFacilityGovernanceRoleMutationVariables {
  input: {
    personId: string;
    facilityId: string;
    facilityGovernanceTitleId: string;
    note?: CreateFacilityGovernanceRoleNoteInput | null;
  };
}

export interface CreateFacilityGovernanceRoleMutationData {
  createFacilityGovernanceRole: FacilityGovernanceRoleMutationResult;
}

export const CREATE_FACILITY_GOVERNANCE_ROLE_MUTATION: TypedDocumentNode<
  CreateFacilityGovernanceRoleMutationData,
  CreateFacilityGovernanceRoleMutationVariables
> = gql`
  mutation CreateFacilityGovernanceRole($input: BackofficeCreateFacilityGovernanceRoleInput!) {
    createFacilityGovernanceRole(input: $input) {
      success
      message
      facilityGovernanceRole {
        id
        status
      }
    }
  }
`;
